<template>
  <div>
    <div class="title">
      <p class="big mt9">等待审核</p>
      <p class="mt6 small">当前借款申请排队中，您需等待{{waitTime}}min</p>
    </div>
    <div class="jin-du">
    </div>
    <div class="more">
      <div class="more-top">
        <div class="more-left">SVIP超值权益</div>
        <div class="more-right" @click="jumpVip">查看更多></div>
      </div>
      <div class="content">
        <div v-for="(item,index) in more" :key="index" class="item" @click="jumpVip">
          <img :src="item.icon" class="item-left"/>
          <div class="item-right">
            <p class="item-title">{{item.title}}</p>
            <p class="item-content">{{item.content}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    lockAmount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      waitTime: 0, // 等待时间
      timer: null // 计时器
    }
  },
  computed: {
    more () {
      return [
        { icon: require('../images/quanyi1.png'), title: '利率优惠67折', content: '每借一万省708元' },
        { icon: require('../images/quanyi2.png'), title: `${this.lockAmount}元提额`, content: '提额成功率100%' },
        { icon: require('../images/quanyi3.png'), title: '首拒可退', content: '7日内可申请退款' },
        { icon: require('../images/quanyi4.png'), title: '大牌美食', content: '美食5折起' }
      ]
    }
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    ...mapActions('withdraw', [
      'getLoanResultX'
    ]),
    getData () {
      this.init()
      this.timer = setInterval(() => {
        this.init()
      }, 10000)
    },
    async init () {
      let { loanApplyNo } = this.$route.query || {}
      const response = await this.getLoanResultX({ loanApplyNo })
      let result = response.data || {}
      this.waitTime = result.queueMinute || ''
      if (result.loanStatusVoEnum === 'LOAN_AUDIT' || (result.loanStatusVoEnum === 'APPLY_FAIL' && !result.svipApplyFailNodeSwitch)) {
        this.$router.replace(
          `/withdraw/result?loanApplyNo=${loanApplyNo}`
        )
      } else if (result.loanStatusVoEnum === 'APPLY_FAIL' && result.svipApplyFailNodeSwitch) {
        this.$router.replace(
          `/withdraw/svip/middle?svipSource=4&purchaseSVIP=middle`
        )
        window.location.reload()
      }
    },
    jumpVip () {
      this.$emit('jumpVip')
    }
  }
}
</script>
<style scoped lang='less'>
@import "../../../../assets/less/mixin.less";

.title{
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .big{
    font-size: 42px;
  }
  .small{
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .jin-du{
    width:670px;
    height:167px;
    margin:36px auto 0;
    background:url('../images/img_tisu@2x.png');
    background-size:cover;
  }
  .more{
    width: 670px;
    height: 370px;
    background: #FFFFFF;
    box-shadow: 0px 20px 30px 0px rgba(231, 231, 231, 0.5);
    border-radius: 20px;
    margin:71px auto 0;
    padding:41px 0 58px;
    .more-top{
      display:flex;
      justify-content: space-between;
      align-items: center;
      padding:0 30px;
    }
    &-left{
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    &-right{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    .content{
      margin-left:-60px;
      display:flex;
      flex-wrap: wrap;
      .item{
        display:flex;
        margin-left:110px;
        align-items: center;
        width:230px;
        margin-top:40px;
        &-left{
          width:53px;
          height:55px;
        }
        &-right{
          margin-left:20px;
        }
        &-title{
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
        &-content{
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }

  }
</style>